// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Ag","summaryPar":"Bg","ratingCategories":"Cg","reviewerInfo":"Dg","reviewTypes":"Eg","expanded":"Fg"};